import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { CustomersContext, ICustomersContext } from '../../customersState/customersContext';
import { EntityStatus } from 'types';
import { ActiveCustomersList } from './ActiveCustomersList';
import { ArchivedCustomersList } from './ArchivedCustomersList';
import { DeletedCustomersList } from './DeletedCustomersList';
import { PaginationComponentNew } from 'components/PaginationComponent/PaginationComponentNew';
import { NoResultsFoundNew } from 'components/NoResultsFound/NoResultsFoundNew';
import { ListingContent } from 'components/Listing/ListingContent';

export const Customers: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, customers, currentPage, countOfItems, status } =
		useContext<ICustomersContext>(CustomersContext);

	return (
		<>
			{customers.customerCount ? (
				<ListingContent testId="Customers">
					{status === EntityStatus.Active && <ActiveCustomersList />}
					{status === EntityStatus.Archived && <ArchivedCustomersList />}
					{status === EntityStatus.Deleted && <DeletedCustomersList />}
					<PaginationComponentNew
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={customers.customerCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</ListingContent>
			) : (
				<NoResultsFoundNew isVisible={!isLoading} />
			)}
		</>
	);
};
